import * as Moment from "moment"
import {LogItem, LogTypes} from "./LogItem"
import {v4 as uuid} from 'uuid';
import {AppConfig} from "../../config";

export class LoggerService {

	public static logs: LogItem[] = []
	public static onLogChanged: () => void = null

	static addError (message: string) {
		LoggerService.addLog({
			id: uuid(),
			message: message,
			type: LogTypes.ERROR
		})
	}

	static addWarning (message: string) {
		LoggerService.addLog({
			id: uuid(),
			message: message,
			type: LogTypes.WARNING
		})
	}

	static addInfo (message: string) {
		LoggerService.addLog({
			id: uuid(),
			message: message,
			type: LogTypes.INFO
		})
	}

	static getLogs():LogItem[]  {
		return LoggerService.logs
	}

	static addLog (log: LogItem) {
		log.time = Moment().format("YYYY-MM-DD HH:mm:ss");
		LoggerService.logs.push(log)
		if (LoggerService.onLogChanged != null) LoggerService.onLogChanged()
	}

	private static logEnabled(): boolean {
		return AppConfig().logging;
	}
}
